export class BrowserInformation {
    osName: string;
    osVersion: string;
    osVersionName: string;
    platform: string;
    browserName: string;
    browserVersion: string;
}